<template>
	<el-container>
		<el-scrollbar>
			<el-header class="header-top" style="height: 50px;"><s-header-top></s-header-top></el-header>
			<el-header class="header"><s-header></s-header></el-header>
			<el-main>
				<div class="content">
					<el-row type="flex" justify="space-between">
						<el-col :span="12">
							<el-breadcrumb separator-class="el-icon-arrow-right">
								<span style="float: left;">当前位置：</span>
								<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
								<el-breadcrumb-item :to="{ path: '/notice' }">通知公告</el-breadcrumb-item>
							</el-breadcrumb>
						</el-col>
						<el-col :span="6">
							<el-input placeholder="输入关键字" v-model="title" @change="getNoticeList"><el-button slot="append" icon="el-icon-search"></el-button></el-input>
						</el-col>
					</el-row>

					<el-row class="page">
						<el-col :span="24" class="table">
							<div class="lists">
								<div class="list" v-for="(item, index) in noticeList" :key="index" @click="goDetail(item)">
									<el-row class="name">
										<el-col :span="24">{{ item.title }}</el-col>
									</el-row>
									<el-row class="label">
										<span>来源：{{ item.source }}</span>
										<span>|</span>
										<span>{{ item.publishdate }}</span>
									</el-row>
								</div>
							</div>
							<pagination v-show="pageTotal>0" :total="pageTotal" :page.sync="currentPage" :limit.sync="pageSize" @pagination="getNoticeList" />
						</el-col>
					</el-row>
				</div>
			</el-main>
			<el-footer class="footer"><s-footer></s-footer></el-footer>
			<el-footer class="copy-right"><s-copyRight></s-copyRight></el-footer>
		</el-scrollbar>
	</el-container>
</template>

<script>
import sHeaderTop from '@/components/header_top';
import sHeader from '@/components/header';
import sFooter from '@/components/footer';
import sCopyRight from '@/components/copy-right';
import Pagination from '@/components/Pagination';
import { dictList, noticeList } from '@/api';
export default {
	name: 'notice',
	components: {
		sHeaderTop,
		sHeader,
		sFooter,
		sCopyRight,
		Pagination
	},
	data() {
		return {
			title: '',
			// 当前页数
			currentPage: 1,
			// 每页默认显示条数
			pageSize: 10,
			// 总条数
			pageTotal: 0,

			noticeList: []
		};
	},
	mounted() {
		if (this.$route.query.keyWord) {
			this.title = this.$route.query.keyWord;
		}
		this.getNoticeList();
	},
	methods: {
		//通知公告列表
		getNoticeList() {
			let _this = this;
			noticeList({
				pageNo: _this.currentPage,
				pageSize: _this.pageSize,
				title: _this.title
			}).then(res => {
				_this.pageTotal = res.data.count;
				_this.noticeList = res.data.list;
			});
		},
		//通知公告详情
		goDetail(item) {
			let routeUrl = this.$router.resolve({
				path: '/noticeDetail', //跳转的路径
				query: {
					//路由传参时push和query搭配使用 ，作用时传递参数
					id: item.id
				}
			});
			window.open(routeUrl.href, '_blank');
		}
	}
};
</script>

<style lang="scss" scoped>
.page {
	min-height: 618px; /*若没有tabs56  height524 若有height468 */
}
.type .el-radio-group {
	display: flex;
	flex-direction: column;
}
.type .el-radio {
	margin-left: 0 !important;
	margin-right: 0 !important;
	margin-bottom: 10px;
}
.table {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-left: 20px;
	padding-right: 20px;
	margin-bottom: 20px;
}
.lists {
	width: 100%;
}
.list {
	border-bottom: 1px solid #dddddd;
	cursor: pointer;
}
.name {
	font-size: 16px;
	padding-top: 10px;
}
.label {
	/* width: 98px; */
	height: 20px;
	color: rgba(153, 153, 153, 1);
	font-size: 14px;
	margin-top: 10px;
	margin-bottom: 10px;
}
.label span {
	margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/notice.vue